import { isString } from './objects';
// biome-ignore lint/suspicious/noExplicitAny: -
export function get(object, path, defaultValue) {
    if (!path || !isString(path)) {
        return defaultValue;
    }
    const parts = path.split('.');
    for (const part of parts) {
        if (!object)
            return defaultValue;
        // biome-ignore lint/style/noParameterAssign: -
        object = object[part];
    }
    return object ?? defaultValue;
}
